import { AIFunction } from '../const';

export interface fc_user_redeem_click {
  click: '关闭按钮' | '联系客服' | '确认兑换';
  entrance: 'sub_pop_coupon' | 'user';
}

export interface fc_purchase_alert_expose {
  from?: AIFunction;
}

export interface fc_uploadStart {
  // cl(素材库）、translate（视频翻译）、swap（视频换脸）、remove（字幕擦除）、avatar video（数字人视频）、avatar clone（数字人克隆）、voice clone（音频克隆）
  from?: AIFunction;
  // 文件后缀、大小、分辨率
  fileInfo: {
    suffix?: string;
    size?: number;
    resolution?: string;
  };
}

export interface fc_uploadResult {
  // cl(素材库）、translate（视频翻译）、swap（视频换脸）、remove（字幕擦除）、avatar video（数字人视频）、avatar clone（数字人克隆）、voice clone（音频克隆）
  from?: AIFunction;
  // 文件后缀、大小、分辨率
  fileInfo: {
    suffix?: string;
    size?: number;
    resolution?: string;
  };
  duration?: number;
  // 上传耗时（ms）
  cost: number;
  // 上传结果
  result: 'success' | 'fail';
  // 错误信息
  reason?: any;
}

// 订阅弹窗类型
export const enum SubscriptionTypeEnum {
  credit = 'credit',
  plan = 'plan',
}

export const enum EventNewID {
  // 用户退出
  LOGIN_OUT = 'login_out',
  // 发送邮箱验证码失败
  SEND_EMAIL_CODE_FAILED = 'send_email_code_failed',
  // 谷歌登录失败
  GOOGLE_LOGIN_FAILED = 'google_login_failed',
  // 苹果登录失败
  APPLE_LOGIN_FAILED = 'apple_login_failed',
  // 登录
  USER_LOGIN = 'user_login',
  // 点击个人中心
  ACCOUNT_CLICK = 'account_click',
  // 兑换码提交
  REDEEMCODE_SUBMIT = 'redeemcode_submit',
  // 商业化弹窗曝光
  SUBSCRIPTION_POP_EXP = 'subscription_pop_exp',
  // 点击支付按钮
  SUBSCRIPTION_POP_CLICK = 'subscription_pop_click',
  // 支付结果
  SUBSCRIPTION_POP_RESULT = 'subscription_pop_result',
  // 热门工具点击
  RECOMMEND_CLICK = 'recommend_click',
  // 功能页访问
  FEATURE_VISIT = 'feature_visit',
  // 素材上传
  ASSET_UPLOAD = 'asset_upload',
  // 提交任务---通用
  TASK_SUBMIT = 'task_submit',
  // 视频翻译任务
  TASK_VIDEO_TRANSLATION = 'task_videotranslation',
  // 图片翻译任务
  TASK_IMAGE_TRANSLATION = 'task_imagetranslation',
  // 智能擦除
  TASK_REMOVAL = 'task_removal',
  // 图片高清
  TASK_IMAGE_ENHANCE = 'task_imageenhance',
  // 下载作品
  CREATIONS_DOWNLOAD = 'creations_download',
  // 作品下载结果
  CREATIONS_DOWNLOAD_RESULT = 'result_download',
  // 积分消耗
  CONSUME_CREDITS = 'consume_credits',
  // 页面崩溃
  PAGE_CRASH = 'page_crash',
  // 产品数字人任务
  PRODUCT_AVATAR_TASK = 'task_proavatar',
  // 数字人视频任务
  AVATAR_VIDEO = 'task_avatar2pro',
  // 登录来源
  LOGIN_IN_SOURCE = 'login_in',
  // 资产后续操作
  ASSET_CLICK = 'asset_click',
  VOICE_USE = 'voice_use',
  // 邀约弹窗面板曝光
  INVITE_ENTRY_VIEW = 'invite_entry_view',
  // 复制邀请链接
  INVITE_LINK_COPY = 'invite_link_copy',
  // 新用户注册成功
  REGISTER_SUCCESS = 'register_success',
}

export type TPlan = 'S1' | 'S2' | 'P1' | 'P2' | 'Credit' | 'Other';
export type TLoginInType = 'Google' | 'Apple' | 'Email';

export const enum StatusEnum {
  SUCCESS = 'success',
  FAIL = 'fail',
}

export const enum PageVisitFrom {
  SIDEBAR = 'sidebar',
  HOME_CLICK = 'home_click',
  FIRST_URL_LOAD = 'first_url_load',
}

export const enum DownloadTier {
  FREE = 'free',
  PAID = 'paid',
}

export const enum UploadTypeEnum {
  SINGLE = 'single',
  BATCH = 'batch',
}

export const enum TranslateModeEnum {
  SUBTITLE = 'subtitle',
  WATERMARK = 'watermark',
  BOTH = 'both',
}

export const enum TaskRemovalTypeEnum {
  FULL = 'Full',
  PARTIAL = 'Partial',
}

export const enum TranslateVoiceTypeEnum {
  AI = 'ai dubbing',
  ORIGINAL = 'original voice',
}
export const enum TranslateSpeedModeEnum {
  CONSTANT = 'constant speed',
  NO_CONSTANT = 'no constant speed',
}
export const enum TOnOffEnum {
  ON = 'on',
  OFF = 'off',
}

export enum ProductAvatarBackgroundType {
  AI = 0, // AI生成背景
  ORIGINAL = 1, // 原背景
  CUSTOM = 2, // 自定义背景
}
export const ProductAvatarBackgroundEnum = {
  [ProductAvatarBackgroundType.AI]: 'auto',
  [ProductAvatarBackgroundType.ORIGINAL]: 'keep',
  [ProductAvatarBackgroundType.CUSTOM]: 'custom',
} as const;

export type ProductAvatarBackgroundValue =
  (typeof ProductAvatarBackgroundEnum)[keyof typeof ProductAvatarBackgroundEnum];

export const enum SubscribeReasonEnum {
  Me = 'me',
  topUpgrade = 'top upgrade',
  topUp = 'top up',
  noWatermark = 'no_watermark',
  vipCaption = 'vip_caption',
  vipVoice = 'vip_voice',
  noWatermarkDownload = 'no_watermark_download',
  voiceSlot = 'voice_slot',
}

export const enum AssetClickEnum {
  download = 'download',
  download_with_watermark = 'download_with_watermark',
  download_no_watermark = 'download_no_watermark',
  rename = 'rename',
  delete = 'delete',
  go_to_aivideo = 'go_to_aivideo',
  go_to_avatarvideo = 'go_to_avatarvideo',
}

export const enum RegisterTypeEnum {
  NORMAL = 'normal',
  INVITE = 'invite',
}

export interface EventNewIDParams {
  [EventNewID.USER_LOGIN]: {
    source: TLoginInType;
  };
  [EventNewID.LOGIN_OUT]: {
    duration: number;
    hasInteraction?: boolean;
    interactionCount?: number;
    isRefresh?: boolean;
  };
  [EventNewID.GOOGLE_LOGIN_FAILED]: {
    loginResult: Record<string, any> | string;
  };
  [EventNewID.APPLE_LOGIN_FAILED]: {
    loginResult: Record<string, any> | string;
  };
  [EventNewID.REDEEMCODE_SUBMIT]: {
    result: 0 | 1;
  };
  [EventNewID.SUBSCRIPTION_POP_EXP]: {
    subscribe_type: SubscriptionTypeEnum;
    source?: AIFunction;
    reason?: SubscribeReasonEnum;
  };
  [EventNewID.SUBSCRIPTION_POP_CLICK]: {
    plan: TPlan;
    source?: AIFunction;
    reason?: SubscribeReasonEnum;
  };
  [EventNewID.SUBSCRIPTION_POP_RESULT]: {
    plan: TPlan;
    result: StatusEnum;
    source?: AIFunction;
    reason?: SubscribeReasonEnum;
  };
  [EventNewID.RECOMMEND_CLICK]: {
    position_id: number;
  };
  [EventNewID.FEATURE_VISIT]: {
    source: AIFunction;
    from: PageVisitFrom;
    duration: number;
  };
  [EventNewID.ASSET_UPLOAD]: {
    source: AIFunction;
    duration?: number;
    resolution?: string;
  };
  [EventNewID.TASK_SUBMIT]: {
    source: AIFunction;
    model_id: string | null;
  };
  [EventNewID.TASK_VIDEO_TRANSLATION]: {
    translate_mode: string;
    source_languages: string;
    target_languages: string;
    subtitle_display: string;
    box_number: number;
    voice_type: TranslateVoiceTypeEnum;
    mode: TranslateSpeedModeEnum;
  };
  [EventNewID.TASK_IMAGE_TRANSLATION]: {
    source_languages: string;
    target_languages: string;
  };
  [EventNewID.TASK_REMOVAL]: {
    box_number: number;
    remove_type: TaskRemovalTypeEnum;
    removal_mode?: TranslateModeEnum;
  };
  [EventNewID.TASK_IMAGE_ENHANCE]: {
    resolution: string;
  };
  [EventNewID.CREATIONS_DOWNLOAD]: {
    source: AIFunction;
    download_tier: DownloadTier;
    model_id: string | null;
    task_id: string;
  };
  [EventNewID.CREATIONS_DOWNLOAD_RESULT]: {
    result: StatusEnum;
    task_id: string;
  };
  [EventNewID.CONSUME_CREDITS]: {
    source: AIFunction;
    credits: number;
  };
  [EventNewID.PAGE_CRASH]: {
    type: number;
  };
  [EventNewID.PRODUCT_AVATAR_TASK]: {
    ratio: string;
    background: ProductAvatarBackgroundValue;
    caption: TOnOffEnum;
  };
  [EventNewID.AVATAR_VIDEO]: {
    caption: TOnOffEnum;
  };
  [EventNewID.LOGIN_IN_SOURCE]: {
    type: TLoginInType;
  };
  [EventNewID.ASSET_CLICK]: {
    source: AIFunction;
    assetClickType: AssetClickEnum;
  };
  [EventNewID.VOICE_USE]: {
    source: AIFunction;
    voiceType: string;
    voiceId?: string;
    name?: string;
  };
  [EventNewID.INVITE_ENTRY_VIEW]: Record<string, never>;
  [EventNewID.INVITE_LINK_COPY]: Record<string, never>;
  [EventNewID.REGISTER_SUCCESS]: {
    inviteCode: string;
    registerType: RegisterTypeEnum;
  };
}

export const enum GoogleEventID {
  SignUp = 'sign_up',
  Purchase = 'purchase',
  BeginCheckout = 'begin_checkout',
  FirstCoreAction = 'first_core_action',
}
